import { PaymentProvider } from './PaymentProvider';
import { PaymentProviders } from './PaymentProviders';

export class CashProvider extends PaymentProvider  {
    constructor() {
        super(PaymentProviders.Cash);
    }
}